export { mapPatientsToOptions, buildPatientOptionLabel } from "../../NewSales/utils/patientUtils";

export const isRegisteredCustomerType = (type) =>
    type === "inpatient" || type === "hospital_patient";

export const buildPatientFromSale = (sale) => {
    if (!sale) return null;

    const patientId =
        sale.patientId ||
        sale.patient_id ||
        sale.patient?._id ||
        sale.patient?.patient_id ||
        null;

    const patientName =
        sale.patientName ||
        sale.patient?.full_name ||
        sale.patient?.patient_name ||
        sale.patient?.name ||
        "";

    const stateCode =
        sale.patientStateCode ||
        sale.stateCode ||
        sale.patient?.stateCode ||
        "";

    if (!patientId) return null;

    return {
        _id: patientId,
        full_name: patientName,
        patient_name: patientName,
        name: patientName,
        stateCode,
    };
};


